import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/models/appState.model';
import { CommonService } from 'src/app/core/services/common/common.service';
import { ExportService } from 'src/app/core/services/export/export.service';
import { FuelGasFlaringService } from 'src/app/core/services/lpg/fuel-gas-flaring.service';
import { FuelGasFlaringData } from 'src/app/state/lpg/fuel-gas-flaring/fuel-gas-flaring.actions';
import { FuelGasFlaringSelector } from 'src/app/state/lpg/fuel-gas-flaring/fuel-gas-flaring.selector';

@Component({
    selector: 'app-fuel-gas-flaring',
    templateUrl: './fuel-gas-flaring.component.html',
    styleUrls: ['./fuel-gas-flaring.component.scss'],
    standalone: false
})
export class FuelGasFlaringComponent implements OnInit {
  month: string = '';

  displayedColumns: string[] = [
    'elementName',
    'totalVolume',
    'totalVolumekSm3',
    'totalMass',
  ];
  displayedColumns2: string[] = [
    'elementName',
    'totalVolume',
    'totalMass',
    'comment',
    'updatedBy',
    'edit',
  ];

  monthlyGasFlarinReport?: any;
  fuelGasFlaring?: any;

  constructor(
    private store: Store<AppState>,
    private fuelGasFlaringService: FuelGasFlaringService,
    private commonService: CommonService,
    private exportService: ExportService
  ) {
  }

  ngOnInit() {
    this.month = this.commonService.formatDate(new Date(), 'YYYY-MM');
    this.store.dispatch(FuelGasFlaringData({ startTime: new Date() }));
    this.store.select(FuelGasFlaringSelector).subscribe((res) => {
      this.monthlyGasFlarinReport = res?.monthlyGasFlaringReport;
      this.fuelGasFlaring = res?.fuelGasFlaring;
    });
  }

  monthChange() {
    this.store.dispatch(
      FuelGasFlaringData({ startTime: new Date(this.month) })
    );
  }

  exportToExcel() {
    this.exportService.exportFuelGasFlaringReports(new Date(this.month));
  }

  getLoading(): boolean {
    return this.exportService.getIsLoading();
  }

  onEditClick(data: any) {
    this.fuelGasFlaringService
      .openEditDialog({ ...data, startTime: this.month })
      .subscribe(() => {
      });
  }

  formatNumberCC(value: any): string {
    return this.commonService.formatNumberCC(value);
  }

  formatNumberMV(value: any): string {
    return this.commonService.formatNumberMV(value);
  }
}
